import { Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { withTranslation } from 'react-i18next';
import { compose } from "recompose";
import { connect } from 'react-redux';

const styles = theme => ({
    noFeedResultsPX: {
        flexDirection: 'column',
        display: 'flex',
        alignItems: 'center',
    },
    noResultsText: {
        fontSize: 24,
        color: '#18181B',
        fontWeight: 600,
        textAlign: 'center',
        lineHeight: '32px',
    },
    noResultsSubtext: {
        fontSize: 10,
        color: '#6B6F7A',
        fontWeight: 400,
        textAlign: 'center',
        lineHeight: '12px',
        marginTop: 8,
    },
    learn: {
        fontSize: 10,
        color: '#6B6F7A',
        fontWeight: 400,
        textAlign: 'center',
        lineHeight: '12px',
        marginTop: 8,
        cursor: 'pointer',
        textDecorationLine: 'underline',
    }
});

const Icon = () => <svg width="72" height="72" viewBox="0 0 72 72" fill="none" xmlns="http://www.w3.org/2000/svg">
<path fill-rule="evenodd" clip-rule="evenodd" d="M38.6155 10.5551C38.9772 9.10842 38.0976 7.6425 36.651 7.28084C35.2043 6.91918 33.7384 7.79873 33.3767 9.24538L31.8414 15.3867C31.4798 16.8333 32.3593 18.2993 33.806 18.6609C35.2526 19.0226 36.7185 18.143 37.0802 16.6964L38.6155 10.5551ZM16.0383 7.20024C17.5295 7.20024 18.7383 8.40908 18.7383 9.90024V10.2711H19.1105C20.6016 10.2711 21.8105 11.48 21.8105 12.9711C21.8105 14.4623 20.6016 15.6711 19.1105 15.6711H18.7383V16.0416C18.7383 17.5327 17.5295 18.7416 16.0383 18.7416C14.5471 18.7416 13.3383 17.5327 13.3383 16.0416V15.6711H12.9691C11.478 15.6711 10.2691 14.4623 10.2691 12.9711C10.2691 11.48 11.478 10.2711 12.9691 10.2711H13.3383V9.90024C13.3383 8.40908 14.5471 7.20024 16.0383 7.20024ZM53.2582 12.9711C53.2582 11.48 54.467 10.2711 55.9582 10.2711H56.3273V9.90024C56.3273 8.40908 57.5362 7.20024 59.0273 7.20024C60.5185 7.20024 61.7273 8.40908 61.7273 9.90024V10.2711H62.0995C63.5907 10.2711 64.7995 11.48 64.7995 12.9711C64.7995 14.4623 63.5907 15.6711 62.0995 15.6711H61.7273V16.0416C61.7273 17.5327 60.5185 18.7416 59.0273 18.7416C57.5362 18.7416 56.3273 17.5327 56.3273 16.0416V15.6711H55.9582C54.467 15.6711 53.2582 14.4623 53.2582 12.9711ZM48.6545 23.3444C49.7089 24.3989 49.7089 26.1084 48.6545 27.1628L45.5838 30.2335C44.5294 31.2879 42.8198 31.2879 41.7654 30.2335C40.711 29.1791 40.711 27.4695 41.7654 26.4151L44.8361 23.3444C45.8905 22.29 47.6 22.29 48.6545 23.3444ZM62.7515 38.6203C64.1981 38.2586 65.0777 36.7927 64.716 35.346C64.3544 33.8994 62.8884 33.0198 61.4418 33.3815L55.3005 34.9168C53.8538 35.2785 52.9743 36.7444 53.3359 38.1911C53.6976 39.6377 55.1635 40.5173 56.6102 40.1556L62.7515 38.6203ZM53.2582 55.96C53.2582 54.4688 54.467 53.26 55.9582 53.26H56.3273V52.8895C56.3273 51.3984 57.5362 50.1895 59.0273 50.1895C60.5185 50.1895 61.7273 51.3984 61.7273 52.8895V53.26H62.0995C63.5907 53.26 64.7995 54.4688 64.7995 55.96C64.7995 57.4512 63.5907 58.66 62.0995 58.66H61.7273V59.0308C61.7273 60.522 60.5185 61.7308 59.0273 61.7308C57.5362 61.7308 56.3273 60.522 56.3273 59.0308V58.66H55.9582C54.467 58.66 53.2582 57.4512 53.2582 55.96Z" fill="#818CF8"/>
<path fill-rule="evenodd" clip-rule="evenodd" d="M23.1817 25.6667C24.0518 25.5102 24.9434 25.7897 25.5685 26.4149L45.5831 46.4294C46.0894 46.9358 46.3739 47.6225 46.3739 48.3386C46.3739 49.3944 45.7585 50.3563 44.7988 50.7962L15.3816 64.2779C14.3098 64.7673 13.114 64.9175 11.9544 64.7083C10.7948 64.499 9.72694 63.9404 8.89378 63.1072C8.06061 62.2741 7.50198 61.2062 7.29275 60.0466C7.08352 58.8871 7.23368 57.6913 7.7231 56.6194L21.2048 27.1993C21.5731 26.3956 22.3115 25.8231 23.1817 25.6667ZM24.4961 32.9792L12.6352 58.8625C12.6351 58.8627 12.6353 58.8623 12.6352 58.8625C12.6033 58.9327 12.5932 59.0117 12.6069 59.0877C12.6207 59.1639 12.6574 59.2341 12.7122 59.2889C12.7669 59.3436 12.8371 59.3803 12.9133 59.3941C12.9892 59.4078 13.0674 59.3981 13.1376 59.3662C13.1379 59.3661 13.1373 59.3664 13.1376 59.3662L39.0209 47.504L24.4961 32.9792Z" fill="#6366F1" fill-opacity="0.95"/>
</svg>


const YouUpToDateItems = ({ classes, t, orgName, results, renderItem }) => {
    return <>
        {results.map((result, idx) => renderItem(idx, result, result.Key))}
        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center', paddingTop: 12, paddingBottom: 24}} className={classes.NoFeedResultsPX}>
            <div>
                <Icon />
            </div>
        <Typography variant="h4" component="h4" className={classes.noResultsText}>{t(`Yeah, you're all up to date!`)}</Typography>
        <Typography variant="h4" component="span" className={classes.noResultsSubtext}>{t(`Great job, you’ve received all the latest updates from {{orgName}}.`, {orgName})}{" "}</Typography>
        <div style={{display: 'flex', alignItems: 'center', marginTop: -9}}>
            <Typography variant="h4" component="span" className={classes.noResultsSubtext}>{t(`Keep scrolling for previous updates.`)}</Typography>
            <Typography style={{marginLeft: 4}} onClick={undefined} variant="h4" component="span" className={classes.learn}>{t(`Learn More`)}</Typography>
        </div>
    </div>
    </>
    
}

const mapStateToProps = (state, ownProps) => ({
    orgName: state.userData?.profileData?.org?.title?.trim?.() ?? "",
})

const mapDispatchToProps = dispatch => {
    return {
        dispatch: dispatch
    }
}

export default compose(
    withStyles(styles),
    withTranslation("feedWidgets"),
    connect(mapStateToProps, mapDispatchToProps),
)(YouUpToDateItems);
